import React$1 from 'react';

const Cross = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "9"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M8.5-.914L9.914.5l-4 4 4 4L8.5 9.914l-4-4-4 4L-.914 8.5l3.999-4-3.999-4L.5-.914l4 3.999z"
}));

export default Cross;
